import { useCallback } from "react";
import { useAtom, useSetAtom } from "jotai";
import {
  cursorAtom,
  selectedNodeTypeAtom,
  SelectableNodeTypes,
  selectedAssetIdAtom,
  deselectAllNodesSetter,
} from "@zapier/canvas-state";

export function useSelectNodeType() {
  const setCursorMode = useSetAtom(cursorAtom);
  const [selectedNodeType, setSelectedNodeType] = useAtom(selectedNodeTypeAtom);
  const setSelectedAssetId = useSetAtom(selectedAssetIdAtom);
  const deselectAllNodes = useSetAtom(deselectAllNodesSetter);

  const resetCursorMode = useCallback(() => {
    setCursorMode("select");
  }, [setCursorMode]);

  const maybeSelectNodeType = useCallback(
    (nodeType: SelectableNodeTypes) => {
      deselectAllNodes();
      setSelectedAssetId(null);

      if (nodeType === selectedNodeType) {
        setSelectedNodeType(null);
      } else {
        resetCursorMode();
        setSelectedNodeType(nodeType);
      }
    },
    [
      deselectAllNodes,
      setSelectedAssetId,
      selectedNodeType,
      setSelectedNodeType,
      resetCursorMode,
    ],
  );

  return { maybeSelectNodeType };
}
